export default "__VITE_ASSET__8Phgx4Re__"